export default {
    title: 'Enter Code',

    input: {
        code: {
            label: 'Code',
            placeholder: 'Write the code'
        },
        username: {
            label: 'Username',
            placeholder: 'Write your username'
        }
    },
    btn: 'Enter game'
}



// WEBPACK FOOTER //
// src/lang/locales/en/codeAccess.js